module.exports = __webpack_public_path__ + "static/img/ys2.7a8dd266.png";